module.exports = __webpack_public_path__ + "static/img/ic-unpaid.438dba56.png";